import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

// Import components
import { MainPackets } from 'components/views/offer_configurator/components/common';

// Import hooks
import { useConfiguratorContext } from 'components/context/configurator/ConfiguratorProvider';

// Import styles
import { AntModalStyled, ModalContent, HeadingFirstStyled } from '../styles';
import { PacketsDescription } from 'components/views/offer_configurator/components/common/styles';
import { ModalCloseButton } from '../components/ModalCloseButton';

export const MainPacketChange = NiceModal.create(() => {
	const { visible, remove } = useModal();
	const { t } = useTranslation('configurator');
	const { mainPacketsDescription } = useConfiguratorContext();

	return (
		<AntModalStyled maskClosable={false} footer={null} width="95%" closable={false} onCancel={remove} visible={visible} centered fullWidth>
			<ModalCloseButton closeModal={remove} withPadding />
			<ModalContent maxWidth="100%" gap={2}>
				<HeadingFirstStyled>{t('modal_main_packets_title')}</HeadingFirstStyled>

				{mainPacketsDescription && <PacketsDescription>{mainPacketsDescription}</PacketsDescription>}

				<MainPackets type="modal" closeModal={remove} />
			</ModalContent>
		</AntModalStyled>
	);
});
